import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/login.vue';
import LayOut from '../views/lay-out/lay-out.vue';
import menuList from "../assets/json/router.json";
import noFound from '../views/404/index.vue';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import store from '../store';
import {
  setSession,
  getSession
} from "@/utils/storage";

Vue.use(VueRouter)
export const registerRouter = [{
  // 首次注册 （教练员）
  path: 'coach-registration',
  name: 'coach-registration',
  component: () => import('../views/coach/first-registration.vue')
}, {
  // 注册信息修改 （教练员）
  path: 'update-coach-registration',
  name: 'update-coach-registration',
  component: () => import('../views/coach/update-registration.vue')
}]
export const athletesRouter = [{
  // 首次注册 （运动员）
  path: 'athletes-registration',
  name: 'athletes-registration',
  component: () => import('../views/athletes/first-registration.vue')
}, {
  // 注册信息修改 （运动员）
  path: 'update-athletes-registration',
  name: 'update-athletes-registration',
  component: () => import('../views/athletes/update-registration.vue')
}]
export const judgeRouter = [{
  // 首次注册（裁判员）
  path: 'judge-registration',
  name: 'judge-registration',
  component: () => import('../views/judge/first-registration.vue')
}, {
  // 裁判员列表
  path: 'update-judge-registration',
  name: 'update-judge-registration',
  component: () => import('../views/judge/update-registration.vue')
}]
// 审核工作（超级管理员、学校审核员、分会审核员公用）
export const auditWork = {
  path: '/audit-work',
  component: LayOut,
  children: [{
    path: 'full-list',
    name: 'full-list',
    component: () => import('../views/audit-work/full-list.vue')
  }, {
    path: 'check-pending',
    name: 'check-pending',
    component: () => import('../views/audit-work/check-pending.vue')
  }, {
    path: 'reviewed',
    name: 'reviewed',
    component: () => import('../views/audit-work/reviewed.vue')
  }]
}
// 审核工作（裁判员）
export const judgeWork = {
  path: '/judge-work',
  component: LayOut,
  children: [{
    path: 'full-list',
    name: 'judge-full-list',
    component: () => import('../views/judge-work/full-list.vue')
  }, {
    path: 'check-pending',
    name: 'judge-check-pending',
    component: () => import('../views/judge-work/check-pending.vue')
  }, {
    path: 'reviewed',
    name: 'judge-reviewed',
    component: () => import('../views/judge-work/reviewed.vue')
  }]
}
// 裁判员评价
export const judgeEvaluate = [{
  path: "/judge-evaluate",
  name: "judge-evaluate",
  component: () => import('../views/judge-evaluate/judge-evaluate.vue'),
}]
// 报表管理（运动员）
export const reportManagement = {
  path: '/report-management',
  component: LayOut,
  children: [{
    path: 'athlete-registration-certificate',
    name: 'athlete-registration-certificate',
    meta: {
      role: [2]
    },
    component: () => import('../views/report-management/athlete-registration-certificate.vue')
  }, {
    path: 'registered-athletes-pool',
    name: 'registered-athletes-pool',
    meta: {
      role: [2]
    },
    component: () => import('../views/report-management/registered-athletes-pool.vue')
  }, {
    path: 'new-registered-athletes',
    name: 'new-registered-athletes',
    meta: {
      role: [2]
    },
    component: () => import('../views/report-management/new-registered-athletes.vue')
  }, {
    path: 'annual-invalid-registered-athletes',
    name: 'annual-invalid-registered-athletes',
    meta: {
      role: [2]
    },
    component: () => import('../views/report-management/annual-invalid-registered-athletes.vue')
  }, {
    path: "athletes-registered-number",
    name: "athletes-registered-number",
    meta: {
      role: [2]
    },
    component: () => import('../views/report-management/registered-number.vue')
  }]
}
// 报表管理（教练员）
export const coachReportManagement = {
  path: '/coach-report-management',
  component: LayOut,
  children: [{
    path: 'coach-registration-certificate',
    name: 'coach-registration-certificate',
    meta: {
      role: [1]
    },
    component: () => import('../views/report-management-coach/coach-registration-certificate.vue')
  }, {
    path: 'registered-coach-pool',
    name: 'registered-coach-pool',
    meta: {
      role: [1]
    },
    component: () => import('../views/report-management-coach/registered-coach-pool.vue')
  }, {
    path: 'new-registered-coach',
    name: 'new-registered-coach',
    meta: {
      role: [1]
    },
    component: () => import('../views/report-management-coach/new-registered-coach.vue')
  }, {
    path: 'annual-invalid-registered-coach',
    name: 'annual-invalid-registered-coach',
    meta: {
      role: [1]
    },
    component: () => import('../views/report-management-coach/annual-invalid-registered-coach.vue')
  }, {
    path: "coach-registered-number",
    name: "coach-registered-number",
    meta: {
      role: [1]
    },
    component: () => import('../views/report-management-coach/registered-number.vue')
  }]
}
// 报表管理（裁判员）
export const judgeReportManagement = {
  path: '/judge-report-management',
  component: LayOut,
  children: [{
    path: 'judge-registration-certificate',
    name: 'judge-registration-certificate',
    component: () => import('../views/judge-report-management/judge-registration-certificate.vue')
  }, {
    path: 'registered-judge-pool',
    name: 'registered-judge-pool',
    component: () => import('../views/judge-report-management/registered-judge-pool.vue')
  }, {
    path: 'new-registered-judge',
    name: 'new-registered-judge',
    component: () => import('../views/judge-report-management/new-registered-judge.vue')
  }, {
    path: 'annual-invalid-registered-judge',
    name: 'annual-invalid-registered-judge',
    component: () => import('../views/judge-report-management/annual-invalid-registered-judge.vue')
  }, {
    path: 'judge-registered-number',
    name: 'judge-registered-number',
    component: () => import('../views/judge-report-management/registered-number.vue')
  }]
}
// 管理功能
export const managementFunction = {
  path: '/management-function',
  component: LayOut,
  children: [{
    path: 'association-management',
    name: 'association-management',
    component: () => import('../views/management-function/association-management.vue')
  }, {
    path: 'school-management',
    name: 'school-management',
    component: () => import('../views/management-function/school-management.vue')
  }, ]
}
// 报名赛事
export const competition = [{
    path: '/basketball',
    component: LayOut,
    children: [{
        path: 'basketball-application-form',
        name: 'basketball-application-form',
        component: () => import('../views/basketball/application-form.vue')
      },
      {
        path: 'basketball-registration-form-view',
        name: 'basketball-registration-form-view',
        component: () => import('../views/basketball/registration-form-view.vue')
      }, {
        path: 'basketball-application-form-review',
        name: 'basketball-application-form-review',
        component: () => import('../views/basketball/application-form-review.vue')
      },
    ]
  }, {
    path: '/football',
    component: LayOut,
    children: [{
        path: 'football-application-form',
        name: 'football-application-form',
        component: () => import('../views/football/application-form.vue')
      },
      {
        path: 'football-registration-form-view',
        name: 'football-registration-form-view',
        component: () => import('../views/football/registration-form-view.vue')
      }, {
        path: 'football-application-form-review',
        name: 'football-application-form-review',
        component: () => import('../views/football/application-form-review.vue')
      },
    ]
  }, {
    path: '/volleyball',
    component: LayOut,
    children: [{
        path: 'volleyball-application-form',
        name: 'volleyball-application-form',
        component: () => import('../views/volleyball/application-form.vue')
      },
      {
        path: 'volleyball-registration-form-view',
        name: 'volleyball-registration-form-view',
        component: () => import('../views/volleyball/registration-form-view.vue')
      }, {
        path: 'volleyball-application-form-review',
        name: 'volleyball-application-form-review',
        component: () => import('../views/volleyball/application-form-review.vue')
      },
    ]
  }, {
    path: '/athletics',
    component: LayOut,
    children: [{
      path: 'athletics-application-form',
      name: 'athletics-application-form',
      component: () => import('../views/athletics/application-form.vue')
    }, {
      path: 'athletics-registration-form-view',
      name: 'athletics-registration-form-view',
      component: () => import('../views/athletics/registration-form-view.vue')
    }, {
      path: 'athletics-application-form-review',
      name: 'athletics-application-form-review',
      component: () => import('../views/athletics/application-form-review.vue')
    }]
  },
  {
    path: "/pingpangball",
    component: LayOut,
    children: [{
      path: 'pingpangball-application-form',
      name: 'pingpangball-application-form',
      component: () => import('../views/pingpangball/application-form.vue')
    }, {
      path: 'pingpangball-registration-form-view',
      name: 'pingpangball-registration-form-view',
      component: () => import('../views/pingpangball/registration-form-view.vue')
    }, {
      path: 'pingpangball-application-form-review',
      name: 'pingpangball-application-form-review',
      component: () => import('../views/pingpangball/application-form-review.vue')
    }]
  }, {
    path: '/badminton',
    component: LayOut,
    children: [{
        path: "badminton-application-form",
        name: "badminton-application-form",
        component: () => import('../views/badminton/application-form.vue')
      },
      {
        path: 'badminton-registration-form-view',
        name: 'badminton-registration-form-view',
        component: () => import('../views/badminton/registration-form-view.vue')
      }, {
        path: 'badminton-application-form-review',
        name: 'badminton-application-form-review',
        component: () => import('../views/badminton/application-form-review.vue')
      }
    ]
  }, {
    path: '/tennis',
    component: LayOut,
    children: [{
        path: "tennis-application-form",
        name: "tennis-application-form",
        component: () => import('../views/tennis/application-form.vue')
      },
      {
        path: 'tennis-registration-form-view',
        name: 'tennis-registration-form-view',
        component: () => import('../views/tennis/registration-form-view.vue')
      }, {
        path: 'tennis-application-form-review',
        name: 'tennis-application-form-review',
        component: () => import('../views/tennis/application-form-review.vue')
      }
    ]
  },{
    path:"/swimming",
    component:LayOut,
    children:[
      {
        path: "swimming-application-form",
        name: "swimming-application-form",
        component: () => import('../views/swimming/application-form.vue')
      },{
        path: 'swimming-registration-form-view',
        name: 'swimming-registration-form-view',
        component: () => import('../views/swimming/registration-form-view.vue')
      }, {
        path: 'swimming-application-form-review',
        name: 'swimming-application-form-review',
        component: () => import('../views/swimming/application-form-review.vue')
      }
    ]
  },{
    path:"/martial",
    component:LayOut,
    children:[
      {
        path: "martial-application-form",
        name: "martial-application-form",
        component: () => import('../views/martial/application-form.vue')
      },{
        path: 'martial-registration-form-view',
        name: 'martial-registration-form-view',
        component: () => import('../views/martial/registration-form-view.vue')
      }, {
        path: 'martial-application-form-review',
        name: 'martial-application-form-review',
        component: () => import('../views/martial/application-form-review.vue')
      }
    ]
  },{
    path:'/aerobics',
    component: LayOut,
    children:[
      {
        path: "aerobics-application-form",
        name: "aerobics-application-form",
        component: () => import('../views/aerobics/application-form.vue')
      },{
        path: 'aerobics-registration-form-view',
        name: 'aerobics-registration-form-view',
        component: () => import('../views/aerobics/registration-form-view.vue')
      }, {
        path: 'aerobics-application-form-review',
        name: 'aerobics-application-form-review',
        component: () => import('../views/aerobics/application-form-review.vue')
      }
    ]
  }
]

// 账号管理
export const accountManagement = [{
  path: 'account-management',
  name: 'account-management',
  component: () => import('../views/account-management/account-management.vue')
}]
// 赛事管理
export const sportsManagement = [{
  path: '/sports',
  component: LayOut,
  children: [{
    path: 'make-management',
    name: 'make-management',
    component: () => import('../views/sports-management/sports-management')
  }, {
    path: 'notice-release',
    name: 'notice-release',
    component: () => import('../views/sports-management/notice-release')
  }]
}]
// 报名详情
export const registrationDetails = [{
  path: '/registration',
  component: LayOut,
  children: [{
    path: 'registration-list',
    name: 'registration-list',
    component: () => import('../views/registration-details/registration-list.vue')
  }]
}]
export const timeManagement = [{
  path: '/time-management',
  name: 'time-management',
  component: () => import('../views/time-management/time-management.vue')
}]
const routes = [{
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/404',
    component: noFound
  },
  {
    path: '/select-regist',
    name: '/select-regist',
    component: () => import('../views/select-regist/select-regist.vue')
  }, {
    path: "*",
    redirect: '/404',
  }, {
    path: '/',
    component: LayOut,
    children: [
      ...registerRouter,
      ...athletesRouter,
      ...judgeRouter,
      ...judgeEvaluate,
      ...timeManagement,
      ...accountManagement,
    ]
  },
  auditWork, judgeWork, reportManagement, coachReportManagement, judgeReportManagement, managementFunction, ...competition, ...sportsManagement, ...registrationDetails,
]

// {
//     "roleList": [3],
//     "title": "裁判员评价",
//     "path": "/judge-evaluate",
//     "name": "judge-evaluate",
//     "icon": "icon-pingjia"
// },

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  routes
})

// 访问非主页路径时，筛选当前角色对应菜单，
function getCurrentRouter(path, userInfo) {
  let result = false;
  let asideMenu = [];
  let currentMenu = null;
  for (let item in menuList) {
    if (menuList[item].type === userInfo.type) {
      currentMenu = menuList[item].router
    }
  }
  currentMenu.filter(item => {
    if (userInfo.hasOwnProperty('matce')) {
      if (userInfo.matce === "signUp") {
        if (item.isHide || item.isCommon) {
          asideMenu.push(item);
        }
      } else {
        if (!item.isHide || item.isCommon) {
          asideMenu.push(item);
        }
      }
    } else {
      asideMenu.push(item);
    }

  })
  asideMenu.filter(item => {
    if (item.children) {
      item.children.filter(temp => {

        if (path.indexOf(item.path + temp.path) >= 0) {
          result = true;
        }
      })
    } else {
      if (path.indexOf(item.path) >= 0) {
        result = true;
      }

    }
  })
  return result;
}

/**
 * 权限稍复杂，前端控制，赶时间，没有动态加载，直接根据type跳转不同页面，如果以后你用这个模板开发其他系统，请重新搭建路由及配置路由
 */
router.beforeEach((to, from, next) => {
  // start progress bar
  NProgress.start();
  let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo')) || "";
  if (userInfo) {
    if (!store.state.userInfo.name) store.commit('setUserInfo', userInfo);
    if (to.path == '/' || to.path == '/login') {
      if (userInfo.type === 1) {
        if (userInfo.currentRole === 3) {
          userInfo.currentRole = 2;
          setSession("userInfo", JSON.stringify(userInfo));
        }
        next({
          path: '/audit-work/full-list'
        })
      } else if (userInfo.type === 2) {
        let path = (userInfo.matce === 'regist' ? 'coach-registration' : '/basketball/basketball-application-form');
        next({
          path: '/audit-work/full-list'
        })
      } else if (userInfo.type === 3) {
        if (userInfo.currentRole === 3) {
          userInfo.currentRole = 2;
          setSession("userInfo", JSON.stringify(userInfo));
        }
        next({
          path: '/audit-work/full-list'
        })
      } else if (userInfo.type === 4) {
        let path = (userInfo.matce === 'regist' ? 'coach-registration' : '/basketball/basketball-application-form');
        next({
          path
        })
      } else {
        if (userInfo.currentRole === 3) {
          userInfo.currentRole = 2;
          setSession("userInfo", JSON.stringify(userInfo));
        }
        next({
          path: '/audit-work/full-list'
        })
      }
    } else {
      let result = getCurrentRouter(to.path, userInfo);
      if (to.path === '/select-regist' || to.path === '/404') {
        next();
      } else {
        if (result) {
          next()
        } else {
          next('/404');
        }
      }
    }
  } else {
    if (to.name == 'Login') {
      next();
    } else {
      next(
        `/login`
      )
      NProgress.done()
    }

  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

export default router